import { useEffect } from "react";

import { AnalyticsEvents, captureAnalyticsEvent } from "@/analytics";
import { useAuth } from "@/auth/auth";
import { AgentIDOnboarding } from "@/components/onboarding/AgentIDOnboarding";
import { AgentPromptOnboarding } from "@/components/onboarding/AgentPromptOnboarding";

export function Onboarding() {
  const { authnProvider } = useAuth();
  const variant = authnProvider === "agentid" ? "agentid" : "agent_prompt";
  useEffect(() => {
    captureAnalyticsEvent(AnalyticsEvents.ONBOARDING_VIEWED, { variant });
  }, [variant]);

  return variant === "agentid" ? <AgentIDOnboarding /> : <AgentPromptOnboarding />;
}
